import { BaseApi } from "@/api/base";
import type { ReportType } from "@/api/reports/dto/reports";
import type { Response } from "@/api/client";

export class ReportsApi extends BaseApi {
  sendReport(report: ReportType, params = ""): Promise<Response<string>> {
    return this.client.get("/reports" + `/${report}` + `?${params}`);
  }
}
